module.exports = __webpack_public_path__ + "static/media/sixteenth.2c6674c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bucket-row/sixteenth.svg
// module id = 378
// module chunks = 0